import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PersistentStorageService } from '../../persistent-storage/persistent-storage.service';
import {
  AcquireBgDBLockAndThenSyncEvents,
  AcquireLockAndThenInitializeAllDBs,
  AcquireUserDBLockAndSyncWashingInStyleInfo,
  AcquireUserDBLockAndThenSyncReceiveCount,
  BulkCountAppDBActionTypes,
  BulkCountAppNoAction,
  InitializeAllDBsAndThenReleaseLock,
  ReleaseUserDBLock,
  SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncReceiveCount,
  SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncStyleInfo,
  SetUserDBAndBackgoundDBAndReleaseLock,
  SyncBctxWiseSentQuantitySuccessAndThenReleaseLock,
  SyncBctxWiseWipQuantitySuccessAndThenReleaseLock,
  SyncEventsAndThenReleaseBgDBLock,
  SyncReceiveCountAndThenReleaseLock,
  SyncReceiveCountSuccessAndThenReleaseLock,
  SyncSendCountSuccessAndThenReleaseLock,
  SyncStyleInfoAndThenReleaseUserDBLock,
  SyncStyleInfoSuccessAndThenReleaseLock,
  UpdateVendorsDetails,
  SyncVendorsToBctxCombinationDataSuccessAndThenReleaseLock,
  UpdateBgDBAndReleaseLockForSyncEvents,
  UpdateUserDBAndSyncSendCountAndThenReleaseLock,
  UpdateUserDBAndSyncBctxWiseSentQuantityAndThenReleaseLock,
  UpdatedUserDBAndSyncBctxWiseWipQuantityAndThenReleaseLock,
  UpdateUserDBAndReleaseLock,
  UpdateUserDBAndSyncVendorsToBctxCombinationDataAndThenReleaseLock,
  CheckStationOrShiftChange,
  AcquireUserDBLockAndSavePendingWork,
  SavePendingWorkAndThenReleaseLock,
  UpdateUserDBAndReleaseLockAndThenRedirectToLandingPage,
  AcquireUserDBLockAndThenSyncTransactions,
  SyncSendTransactionsAndThenReleaseLock,
  SyncReceiveTransactionsAndThenReleaseLock,
  SyncTransactionsSuccessAndThenReleaseLock,
  AcquireUserDBLockAndSaveEvent,
  SaveSendEventkAndThenReleaseLock,
  SaveReceiveEventkAndThenReleaseLock,
  UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage,
  AcquireUserAndBgDBLockAndThenReconcileForWashing,
  ReconcileUserDBAndBgDBAndThenReleaseLocksForWashing,
  SetUserDBAndBgDBAndReleaseLocksWithChainsForWashing,
  SyncVendors,
  InitVendorDB,
  AcquireUserDBLockAndUpdatePendingWork,
  UpdatePendingWorkAndThenReleaseLock,
  SetInitialVendorsDBAndSyncVendors,
  AcquireUserDBLockAndRemoveTransaction,
  RemoveTransactionAndThenReleaseLock,
  AcquireUserDBLockAndUndoWashingSendEvent,
  AcquireUserDBLockAndUndoWashingReceiveEvent,
} from './bulk-count-app-db.action';
import { switchMap, catchError, take, map, concatMap } from 'rxjs/operators';
import { EMPTY, forkJoin, from, of } from 'rxjs';
import { Action } from '@ngrx/store';
import {
  AppMasterDBActionTypes,
  AppMasterDBFacade,
  BulkCountAppFacade,
  ChangeStation,
  InitStoreFacade,
  ReleaseBgDBLock,
  getBulkCountAppInitialState,
} from '@monorepo/core-data';
import { BulkCountAppComputationHelper, InputAppAPIHelperUtil } from '@monorepo/utils';
import { BulkCountAppDataService, InputAppDataService, CustomLoggerService } from '@monorepo/services';
import produce from 'immer';
import {
  TBulkCountAppUserActualsDB,
  TBulkWashingEventType,
  TBulkWashingReceiveEvent,
  TBulkWashingSendEvent,
  TSizeQuantity,
  TREQUEST_BulkWashSentQuantityRequest,
  TREQUEST_WashReceiveTransactionListingRequest,
  TREQUEST_WashSendTransactionListingRequest,
  TREQUEST_WashReceiveTransactionUndo,
  TREQUEST_WashSendTransactionUndo,
  TREQUEST_WashingReceiveBctxDataRequest,
  TREQUEST_WashingReceiveQuantityRequest,
  TREQUEST_WashingSentQuantityRequest,
  TREQUEST_WipByBctxRequest,
  TRESPONSE_BulkWashSentQuantityResponse,
  TRESPONSE_WipByBctxResponse,
  TSizeToSavedCountMap,
  TSizeToUserDBActualMapItem,
  TSizeToUserDBWipMapItem,
} from '@monorepo/types';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class BulkCountAppEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private initStoreFacade: InitStoreFacade,
    private appMasterDBFacade: AppMasterDBFacade,
    private bulkCountAppFacade: BulkCountAppFacade,
    private inputAppAPIHelperUtil: InputAppAPIHelperUtil,
    private inputAppDataService: InputAppDataService,
    private bulkCountAppDataService: BulkCountAppDataService,
    private persistentStorageService: PersistentStorageService,
    private customLoggerService: CustomLoggerService,
    private translate: TranslateService,
  ) {}

  AcquireLockAndThenInitializeAllDBs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType<AcquireLockAndThenInitializeAllDBs>(BulkCountAppDBActionTypes.AcquireLockAndThenInitializeAllDBs),
      switchMap((action) => {
        return this.bulkCountAppFacade.acquireUserAndBgDBLock('INIT_PENDING').pipe(
          take(1),
          switchMap(([bgLockResult, userLockResult]) => {
            if (bgLockResult.status === 'SUCCESS' && userLockResult.status === 'SUCCESS') {
              return of(new InitializeAllDBsAndThenReleaseLock(action.bulkWashingEventType));
            } else {
              if (userLockResult.status === 'FAILURE')
                this.inputAppAPIHelperUtil.showPopup('Error', userLockResult.message);
              else if (bgLockResult.status === 'FAILURE')
                this.inputAppAPIHelperUtil.showPopup('Error', bgLockResult.message);
              if (bgLockResult.status === 'SUCCESS') return of(new ReleaseBgDBLock());
              else if (userLockResult.status === 'SUCCESS') return of(new ReleaseUserDBLock());
              return of(new BulkCountAppNoAction());
            }
          }),
        );
      }),
    );
  });

  InitializeAllDBsAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<InitializeAllDBsAndThenReleaseLock>(BulkCountAppDBActionTypes.InitializeAllDBsAndThenReleaseLock),
      switchMap((action) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          map((localStorageDb) => {
            return [localStorageDb, action] as const;
          }),
        ),
      ),
      switchMap(([userDB, action]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_BACKGROUND_DB]')).pipe(
          map((bgDB) => {
            return [userDB, bgDB, action] as const;
          }),
        ),
      ),
      switchMap(([userDB, bgDB, action]) => {
        return this.initStoreFacade.getNextCacheResetTimestamp().pipe(
          take(1),
          map((nextCacheResetTimestamp) => [userDB, bgDB, action, nextCacheResetTimestamp] as const),
        );
      }),
      switchMap(([userDB, bgDB, action, nextCacheResetTimestamp]) => {
        const isInit = !userDB;
        const isReload = !isInit && userDB.dailyCache.nextCacheResetTimestamp === nextCacheResetTimestamp;
        const inputAppInitialState = getBulkCountAppInitialState(nextCacheResetTimestamp);
        userDB = userDB || inputAppInitialState.userDB;
        bgDB = bgDB || inputAppInitialState.bgDB;
        return this.bulkCountAppFacade
          .reconcileUserAndBgEventsDB(userDB, bgDB, nextCacheResetTimestamp, action.bulkWashingEventType)
          .pipe(
            take(1),
            map(([updatedUserDB, updatedBgDB]) => {
              return [updatedUserDB, updatedBgDB, action, isInit, isReload] as const;
            }),
          );
      }),
      switchMap(([updatedUserDB, updatedBgDB, action, isInit, isReload]) => {
        return from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_BACKGROUND_DB]', updatedBgDB)).pipe(
          take(1),
          switchMap(() => {
            return from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', updatedUserDB)).pipe(
              take(1),
              map(() => [updatedUserDB, updatedBgDB, action, isInit, isReload] as const),
            );
          }),
        );
      }),
      switchMap(([updatedUserDB, updatedBgDB, action, isInit, isReload]) => {
        if (isReload || updatedBgDB.persistanceCache.pastDaysList.length) {
          return of(new SetUserDBAndBackgoundDBAndReleaseLock(updatedUserDB, updatedBgDB));
        } else {
          if (action.bulkWashingEventType === 'SEND') {
            return of(
              new SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncStyleInfo(updatedUserDB, updatedBgDB, {
                isInit: isInit,
                isReload: isReload,
                isDayEnd: !(isInit || isReload),
                userDB: updatedUserDB,
                bgDB: updatedBgDB,
              }),
            );
          } else {
            return of(
              new SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncReceiveCount(updatedUserDB, updatedBgDB, {
                isInit: isInit,
                isReload: isReload,
                isDayEnd: !(isInit || isReload),
                userDB: updatedUserDB,
                bgDB: updatedBgDB,
              }),
            );
          }
        }
      }),
    ),
  );

  SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncStyleInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncStyleInfo>(
        BulkCountAppDBActionTypes.SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncStyleInfo,
      ),
      switchMap((action) => {
        this.bulkCountAppFacade.emitInitBulkCountUserDBAndBgDBSubscription(action.initInfo);
        return of(new BulkCountAppNoAction());
      }),
    ),
  );

  AcquireUserDBLockAndSyncWashingInStyleInfo$ = createEffect(() => {
    return this.actions$.pipe(
      ofType<AcquireUserDBLockAndSyncWashingInStyleInfo>(
        BulkCountAppDBActionTypes.AcquireUserDBLockAndSyncWashingInStyleInfo,
      ),
      switchMap((action) => {
        return this.bulkCountAppFacade.acquireUserDBLock('BCTX_SYNCING').pipe(
          take(1),
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new SyncStyleInfoAndThenReleaseUserDBLock();
            } else {
              this.inputAppAPIHelperUtil.showPopup('Error', res.message);
              return new BulkCountAppNoAction();
            }
          }),
        );
      }),
    );
  });

  SyncStyleInfoAndThenReleaseUserDBLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncStyleInfoAndThenReleaseUserDBLock>(BulkCountAppDBActionTypes.SyncStyleInfoAndThenReleaseUserDBLock),
      switchMap((action) =>
        this.bulkCountAppFacade.getBusinessContextDataPayload().pipe(
          take(1),
          map((payload) => {
            return [payload, action] as const;
          }),
        ),
      ),
      switchMap(([payload, action]) => {
        return from(this.inputAppAPIHelperUtil.presentLoading('Loading bctx...')).pipe(
          take(1),
          map(() => {
            return [payload, action] as const;
          }),
        );
      }),
      switchMap(([payload, action]) =>
        this.inputAppDataService.getBusninessContextData(payload).pipe(
          take(1),
          switchMap((businessContextData) => {
            return from(this.inputAppAPIHelperUtil.dismissLoading()).pipe(
              take(1),
              map(() => {
                return new SyncStyleInfoSuccessAndThenReleaseLock(businessContextData);
              }),
            );
          }),
          catchError((error) => {
            this.customLoggerService.error(
              'SyncStyleInfoAndThenReleaseUserDBLock: getBusninessContextData API call failed',
              JSON.stringify(error),
            );
            this.inputAppAPIHelperUtil.dismissLoading();
            this.inputAppAPIHelperUtil.showPopup('Error', 'something went wrong in fetching bctx').catch(console.error);
            return of(new ReleaseUserDBLock());
          }),
        ),
      ),
    ),
  );

  SyncStyleInfoSuccessAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncStyleInfoSuccessAndThenReleaseLock>(BulkCountAppDBActionTypes.SyncStyleInfoSuccessAndThenReleaseLock),
      switchMap((action) =>
        this.bulkCountAppFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationIdAndShiftId) => {
            return [action.businessContextData, selectedStationIdAndShiftId] as const;
          }),
        ),
      ),
      switchMap(([businessContextData, selectedStationIdAndShiftId]) => {
        return this.bulkCountAppFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((bctxKeysOrder) => [businessContextData, selectedStationIdAndShiftId, bctxKeysOrder] as const),
        );
      }),
      switchMap(([businessContextData, selectedStationIdAndShiftId, bctxKeysOrder]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          map((currentDB) => {
            const lineMapItem = BulkCountAppComputationHelper.createInitialBulkCountSendAppLineMapItem(
              businessContextData,
              selectedStationIdAndShiftId.shiftId,
              bctxKeysOrder,
            );
            const updatedDailyCache = BulkCountAppComputationHelper.getMergedBulkCountDB(
              currentDB.dailyCache,
              lineMapItem,
              selectedStationIdAndShiftId,
              false,
            );
            currentDB = produce(currentDB, (draft) => {
              draft.dailyCache = updatedDailyCache;
            });
            currentDB = produce(currentDB, (draft) => {
              draft.dailyCache.lastStyleSyncInfoTimestamp = new Date().getTime();
            });
            return [currentDB] as const;
          }),
        ),
      ),
      switchMap(([currentDB]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', currentDB)).pipe(
          map(() => new UpdateUserDBAndSyncSendCountAndThenReleaseLock(currentDB)),
        ),
      ),
    ),
  );

  UpdateUserDBAndSyncSendCountAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdateUserDBAndSyncSendCountAndThenReleaseLock>(
        BulkCountAppDBActionTypes.UpdateUserDBAndSyncSendCountAndThenReleaseLock,
      ),
      switchMap((action) =>
        this.appMasterDBFacade.getWashingAppDetailsWithAdditionalInfo().pipe(
          take(1),
          map((appDetails) => appDetails),
        ),
      ),
      switchMap((appDetails) =>
        from(this.inputAppAPIHelperUtil.presentLoading('Loading worked count for today...')).pipe(
          take(1),
          map(() => {
            const payload: TREQUEST_WashingSentQuantityRequest = {
              appDetails,
            };
            return payload;
          }),
        ),
      ),
      switchMap((payload) =>
        this.bulkCountAppDataService.getSentCount(payload).pipe(
          map((res) => {
            this.inputAppAPIHelperUtil.dismissLoading();
            return new SyncSendCountSuccessAndThenReleaseLock(res.washSentQuantity);
          }),
          catchError((error) =>
            from(
              this.inputAppAPIHelperUtil.showPopup(
                'Error',
                'Something went wrong getting total worked count for today',
              ),
            ).pipe(
              take(1),
              map(() => {
                console.log('[LOAD_SENT_COUNT_ERROR]', error);
                this.inputAppAPIHelperUtil.dismissLoading();
                return new ReleaseUserDBLock();
              }),
            ),
          ),
        ),
      ),
    ),
  );

  SyncSendCountSuccessAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncSendCountSuccessAndThenReleaseLock>(BulkCountAppDBActionTypes.SyncSendCountSuccessAndThenReleaseLock),
      switchMap((action) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            return produce(currentDB, (draft) => {
              draft.dailyCache.totalCount = action.sentCount;
            });
          }),
        ),
      ),
      switchMap((curretDB) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', curretDB)).pipe(
          take(1),
          map(() => new UpdateUserDBAndSyncBctxWiseSentQuantityAndThenReleaseLock(curretDB)),
        ),
      ),
    ),
  );

  UpdateUserDBAndSyncBctxWiseSentQuantityAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdateUserDBAndSyncBctxWiseSentQuantityAndThenReleaseLock>(
        BulkCountAppDBActionTypes.UpdateUserDBAndSyncBctxWiseSentQuantityAndThenReleaseLock,
      ),
      switchMap((action) =>
        this.appMasterDBFacade.getWashingAppDetailsWithAdditionalInfo().pipe(
          take(1),
          map((appDetails) => appDetails),
        ),
      ),
      switchMap((appDetails) =>
        from(this.inputAppAPIHelperUtil.presentLoading('Loading bctx wise worked quantity...')).pipe(
          take(1),
          map(() => {
            const payload: TREQUEST_BulkWashSentQuantityRequest = {
              factoryId: appDetails.factoryId,
              appDetails,
            };
            return payload;
          }),
        ),
      ),
      switchMap((payload) =>
        this.bulkCountAppDataService.getBctxWiseSentQuantity(payload).pipe(
          map((res) => {
            this.inputAppAPIHelperUtil.dismissLoading();
            return new SyncBctxWiseSentQuantitySuccessAndThenReleaseLock(res);
          }),
          catchError((error) =>
            from(this.inputAppAPIHelperUtil.showPopup('Error', 'Something went wrong')).pipe(
              take(1),
              map(() => {
                console.log('[LOAD_BCTX_WISE_COUNT_ERROR]', error);
                this.inputAppAPIHelperUtil.dismissLoading();
                return new ReleaseUserDBLock();
              }),
            ),
          ),
        ),
      ),
    ),
  );

  SyncBctxWiseSentQuantitySuccessAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncBctxWiseSentQuantitySuccessAndThenReleaseLock>(
        BulkCountAppDBActionTypes.SyncBctxWiseSentQuantitySuccessAndThenReleaseLock,
      ),
      switchMap((action) =>
        this.bulkCountAppFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => [action, selectedStationAndShiftId] as const),
        ),
      ),
      switchMap(([action, selectedStationAndShiftId]) =>
        this.bulkCountAppFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((orderKeys) => [action, selectedStationAndShiftId, orderKeys] as const),
        ),
      ),
      switchMap(([action, selectedStationAndShiftId, orderKeys]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            const { stationId, shiftId } = selectedStationAndShiftId;
            const res: TRESPONSE_BulkWashSentQuantityResponse = action.res;
            res.bulkWashSentQuantities.forEach((bulkWashSentQuantity) => {
              const bctxKey = BulkCountAppComputationHelper.getUniqueBctxKeyAndVendorIdWithOrder(
                orderKeys,
                bulkWashSentQuantity.bctxWithoutSize,
                undefined,
              );
              bulkWashSentQuantity.sizeQuantities.forEach((sizeQuantity) => {
                currentDB = produce(currentDB, (currentDBDraft) => {
                  if (
                    currentDBDraft.dailyCache.lineMap[stationId] &&
                    currentDBDraft.dailyCache.lineMap[stationId].shiftMap[shiftId] &&
                    currentDBDraft.dailyCache.lineMap[stationId].shiftMap[shiftId][bctxKey] &&
                    currentDBDraft.dailyCache.lineMap[stationId].shiftMap[shiftId][bctxKey].sizeMap[sizeQuantity.size]
                  ) {
                    currentDBDraft.dailyCache.lineMap[stationId].shiftMap[shiftId][bctxKey].sizeMap[
                      sizeQuantity.size
                    ].totalCompletedCount = sizeQuantity.quantity;
                  }
                });
              });
            });
            return currentDB;
          }),
        ),
      ),
      switchMap((curretDB) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', curretDB)).pipe(
          take(1),
          map(() => new UpdatedUserDBAndSyncBctxWiseWipQuantityAndThenReleaseLock(curretDB)),
        ),
      ),
    ),
  );

  UpdatedUserDBAndSyncBctxWiseWipQuantityAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdatedUserDBAndSyncBctxWiseWipQuantityAndThenReleaseLock>(
        BulkCountAppDBActionTypes.UpdatedUserDBAndSyncBctxWiseWipQuantityAndThenReleaseLock,
      ),
      switchMap((action) =>
        this.appMasterDBFacade.getWashingAppDetailsWithAdditionalInfo().pipe(
          take(1),
          map((appDetails) => appDetails),
        ),
      ),
      switchMap((appDetails) =>
        this.bulkCountAppFacade.getBctxWithSizeList().pipe(
          take(1),
          map((bctxList) => {
            return [appDetails, bctxList] as const;
          }),
        ),
      ),
      switchMap(([appDetails, bctxList]) =>
        from(this.inputAppAPIHelperUtil.presentLoading('Loading bctx wise wip quantity...')).pipe(
          take(1),
          map(() => {
            const payload: TREQUEST_WipByBctxRequest = {
              factoryId: appDetails.factoryId,
              appDetails,
              bctxList,
            };
            return payload;
          }),
        ),
      ),
      switchMap((payload) =>
        this.bulkCountAppDataService.getBctxWiseWipQuantity(payload).pipe(
          map((res) => {
            this.inputAppAPIHelperUtil.dismissLoading();
            return new SyncBctxWiseWipQuantitySuccessAndThenReleaseLock(res);
          }),
          catchError((error) =>
            from(this.inputAppAPIHelperUtil.showPopup('Error', 'Something went wrong')).pipe(
              take(1),
              map(() => {
                console.log('[LOAD_BCTX_WISE_WIP_ERROR]', error);
                this.inputAppAPIHelperUtil.dismissLoading();
                return new ReleaseUserDBLock();
              }),
            ),
          ),
        ),
      ),
    ),
  );

  SyncBctxWiseWipQuantitySuccessAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncBctxWiseWipQuantitySuccessAndThenReleaseLock>(
        BulkCountAppDBActionTypes.SyncBctxWiseWipQuantitySuccessAndThenReleaseLock,
      ),
      switchMap((action) =>
        this.bulkCountAppFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => [action, selectedStationAndShiftId] as const),
        ),
      ),
      switchMap(([action, selectedStationAndShiftId]) =>
        this.bulkCountAppFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((orderKeys) => [action, selectedStationAndShiftId, orderKeys] as const),
        ),
      ),
      switchMap(([action, selectedStationAndShiftId, orderKeys]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            const { stationId, shiftId } = selectedStationAndShiftId;
            const res: TRESPONSE_WipByBctxResponse = action.res;
            res.wips.forEach((wipByBctxItem) => {
              const bctxKey = BulkCountAppComputationHelper.getUniqueBctxKeyAndVendorIdWithOrder(
                orderKeys,
                wipByBctxItem.bctxWithoutSize,
                undefined,
              );
              wipByBctxItem.sizeWipQuantities.forEach((sizeWipQuantity) => {
                const updatedLineMap = BulkCountAppComputationHelper.backFillBctxInUserLineMap(
                  wipByBctxItem.bctxWithoutSize,
                  sizeWipQuantity.size,
                  bctxKey,
                  currentDB.dailyCache.lineMap,
                  stationId,
                  shiftId,
                );
                currentDB = produce(currentDB, (currentDBDraft) => {
                  currentDBDraft.dailyCache.lineMap = updatedLineMap;
                });
                currentDB = produce(currentDB, (currentDBDraft) => {
                  currentDBDraft.dailyCache.lineMap[stationId].bctxAndVendorWipMap[bctxKey].sizeMap[
                    sizeWipQuantity.size
                  ].wipQty = sizeWipQuantity.wip;
                });
              });
            });
            return currentDB;
          }),
        ),
      ),
      switchMap((curretDB) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', curretDB)).pipe(
          take(1),
          map(() => new UpdateUserDBAndReleaseLock(curretDB)),
        ),
      ),
    ),
  );

  InitVendorDB$ = createEffect(() =>
    this.actions$.pipe(
      ofType<InitVendorDB>(BulkCountAppDBActionTypes.InitVendorDB),
      switchMap((action) => {
        return this.initStoreFacade.getNextCacheResetTimestamp().pipe(
          take(1),
          map((nextCacheResetTimestamp) => [nextCacheResetTimestamp] as const),
        );
      }),
      switchMap(([nextCacheResetTimestamp]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_VENDORS_DB]')).pipe(
          switchMap((vendorDB) => {
            if (vendorDB) {
              return of(new UpdateVendorsDetails(vendorDB));
            } else {
              const inputAppInitialState = getBulkCountAppInitialState(nextCacheResetTimestamp);
              return from(
                this.persistentStorageService.set(
                  '[APP][INPUT_APP_BULK_COUNT_VENDORS_DB]',
                  inputAppInitialState.vendors,
                ),
              ).pipe(
                take(1),
                map(() => {
                  return new SetInitialVendorsDBAndSyncVendors(inputAppInitialState.vendors);
                }),
              );
            }
          }),
        ),
      ),
    ),
  );

  SetInitialVendorsDBAndSyncVendors$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SetInitialVendorsDBAndSyncVendors>(BulkCountAppDBActionTypes.SetInitialVendorsDBAndSyncVendors),
      switchMap((action) => of(new SyncVendors(false))),
    ),
  );

  SyncVendors$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncVendors>(BulkCountAppDBActionTypes.SyncVendors),
      switchMap((action) =>
        this.appMasterDBFacade.getWashingAppDetailsWithAdditionalInfo().pipe(
          take(1),
          map((appDetails) => [appDetails.factoryId, action.showLoader] as const),
        ),
      ),
      switchMap(([factoryId, showLoader]) => {
        if (showLoader) {
          return from(this.inputAppAPIHelperUtil.presentLoading('Loading vendors...')).pipe(
            take(1),
            map(() => [factoryId, showLoader] as const),
          );
        } else return of([factoryId, showLoader] as const);
      }),
      switchMap(([factoryId, showLoader]) => {
        return this.bulkCountAppFacade.getConfigurations().pipe(
          take(1),
          map(({ departmentId }) => {
            return [factoryId, showLoader, departmentId] as const;
          }),
        );
      }),
      switchMap(([factoryId, showLoader, departmentId]) =>
        this.bulkCountAppDataService.getVendorList({ factoryId, department: departmentId }).pipe(
          switchMap((res) => {
            return from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_VENDORS_DB]', res)).pipe(
              take(1),
              map(() => {
                if (showLoader) this.inputAppAPIHelperUtil.dismissLoading();
                return new UpdateVendorsDetails(res);
              }),
            );
          }),
          catchError((error) => {
            if (showLoader) {
              return from(
                this.inputAppAPIHelperUtil.showPopup('Error', 'Something went wrong syncing vendor details'),
              ).pipe(
                take(1),
                map(() => {
                  console.log('[LOAD_VENDOR_LIST_ERROR]', error);
                  this.inputAppAPIHelperUtil.dismissLoading();
                  return new BulkCountAppNoAction();
                }),
              );
            } else {
              return of(new BulkCountAppNoAction());
            }
          }),
        ),
      ),
    ),
  );

  SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncReceiveCount$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncReceiveCount>(
        BulkCountAppDBActionTypes.SetUserAndBgDBAndReleaseLockAndThenAcquireLockAndThenSyncReceiveCount,
      ),
      switchMap((action) => {
        this.bulkCountAppFacade.emitInitBulkCountUserDBAndBgDBSubscription(action.initInfo);
        return of(new BulkCountAppNoAction());
      }),
    ),
  );

  AcquireUserDBLockAndThenSyncReceiveCount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType<AcquireUserDBLockAndThenSyncReceiveCount>(
        BulkCountAppDBActionTypes.AcquireUserDBLockAndThenSyncReceiveCount,
      ),
      switchMap((action) => {
        return this.bulkCountAppFacade.acquireUserDBLock('BULK_RECEIVE_INIT').pipe(
          take(1),
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new SyncReceiveCountAndThenReleaseLock();
            } else {
              this.inputAppAPIHelperUtil.showPopup('Error', res.message);
              return new BulkCountAppNoAction();
            }
          }),
        );
      }),
    );
  });

  SyncReceiveCountAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncReceiveCountAndThenReleaseLock>(BulkCountAppDBActionTypes.SyncReceiveCountAndThenReleaseLock),
      switchMap((action) =>
        this.appMasterDBFacade.getWashingAppDetailsWithAdditionalInfo().pipe(
          take(1),
          map((appDetails) => appDetails),
        ),
      ),
      switchMap((appDetails) =>
        from(this.inputAppAPIHelperUtil.presentLoading('Loading worked count for today...')).pipe(
          take(1),
          map(() => {
            const payload: TREQUEST_WashingReceiveQuantityRequest = {
              appDetails,
            };
            return payload;
          }),
        ),
      ),
      switchMap((payload) =>
        this.bulkCountAppDataService.getReceiveCount(payload).pipe(
          map((res) => {
            this.inputAppAPIHelperUtil.dismissLoading();
            return new SyncReceiveCountSuccessAndThenReleaseLock(res.washReceiveQuantity);
          }),
          catchError((error) =>
            from(
              this.inputAppAPIHelperUtil.showPopup('Error', 'Something went wrong fetching todays total worked count'),
            ).pipe(
              take(1),
              map(() => {
                console.log('[LOAD_RECEIVE_COUNT_ERROR]', error);
                this.inputAppAPIHelperUtil.dismissLoading();
                return new ReleaseUserDBLock();
              }),
            ),
          ),
        ),
      ),
    ),
  );

  SyncReceiveCountSuccessAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncReceiveCountSuccessAndThenReleaseLock>(
        BulkCountAppDBActionTypes.SyncReceiveCountSuccessAndThenReleaseLock,
      ),
      switchMap((action) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            return produce(currentDB, (draft) => {
              draft.dailyCache.totalCount = action.receiveCount;
            });
          }),
        ),
      ),
      switchMap((curretDB) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', curretDB)).pipe(
          take(1),
          map(() => new UpdateUserDBAndSyncVendorsToBctxCombinationDataAndThenReleaseLock(curretDB)),
        ),
      ),
    ),
  );

  UpdateUserDBAndSyncVendorsToBctxCombinationDataAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdateUserDBAndSyncVendorsToBctxCombinationDataAndThenReleaseLock>(
        BulkCountAppDBActionTypes.UpdateUserDBAndSyncVendorsToBctxCombinationDataAndThenReleaseLock,
      ),
      switchMap((action) =>
        this.appMasterDBFacade.getWashingAppDetailsWithAdditionalInfo().pipe(
          take(1),
          map((appDetails) => appDetails),
        ),
      ),
      switchMap((appDetails) =>
        from(this.inputAppAPIHelperUtil.presentLoading('Loading bctx wise wip quantity...')).pipe(
          take(1),
          map(() => {
            const payload: TREQUEST_WashingReceiveBctxDataRequest = {
              appDetails,
            };
            return payload;
          }),
        ),
      ),
      switchMap((payload) =>
        this.bulkCountAppDataService.getVendorsToBctxCombinationData(payload).pipe(
          map((res) => {
            this.inputAppAPIHelperUtil.dismissLoading();
            return new SyncVendorsToBctxCombinationDataSuccessAndThenReleaseLock(res);
          }),
          catchError((error) =>
            from(this.inputAppAPIHelperUtil.showPopup('Error', 'Something went wrong')).pipe(
              take(1),
              map(() => {
                console.log('[LOAD_BCTX_WISE_WIP_ERROR]', error);
                this.inputAppAPIHelperUtil.dismissLoading();
                return new ReleaseUserDBLock();
              }),
            ),
          ),
        ),
      ),
    ),
  );

  SyncVendorsToBctxCombinationDataSuccessAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncVendorsToBctxCombinationDataSuccessAndThenReleaseLock>(
        BulkCountAppDBActionTypes.SyncVendorsToBctxCombinationDataSuccessAndThenReleaseLock,
      ),
      switchMap((action) =>
        this.bulkCountAppFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => [action, selectedStationAndShiftId] as const),
        ),
      ),
      switchMap(([action, selectedStationAndShiftId]) =>
        this.bulkCountAppFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((orderKeys) => [action, selectedStationAndShiftId, orderKeys] as const),
        ),
      ),
      switchMap(([action, selectedStationAndShiftId, orderKeys]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            const { shiftId, stationId } = selectedStationAndShiftId;
            // const res: TRESPONSE_WashingReceiveBctxDataResponse = action.res;
            //Filtering the sizeInfo if cumulativeReceivedQuantity equal to cumulativeSentQuantity, till backend doesn't send this
            const res = this.bulkCountAppFacade.getFilteredVendorWiseBctxData(
              action.res,
              orderKeys,
              stationId,
              shiftId,
              currentDB,
            );
            const lineMapItem = BulkCountAppComputationHelper.createInitialBulkCountReceiveAppLineMapItem(
              res,
              selectedStationAndShiftId.shiftId,
              orderKeys,
            );
            const updatedDailyCache = BulkCountAppComputationHelper.getMergedBulkCountDB(
              currentDB.dailyCache,
              lineMapItem,
              selectedStationAndShiftId,
              true,
            );
            currentDB = produce(currentDB, (currentDBDraft) => {
              currentDBDraft.dailyCache = updatedDailyCache;
            });
            currentDB = produce(currentDB, (currentDBDraft) => {
              currentDBDraft.dailyCache.lastStyleSyncInfoTimestamp = new Date().getTime();
            });
            return currentDB;
          }),
        ),
      ),
      switchMap((curretDB) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', curretDB)).pipe(
          take(1),
          map(() => new UpdateUserDBAndReleaseLock(curretDB)),
        ),
      ),
    ),
  );

  AcquireUserAndBgDBLockAndThenReconcileForWashing$ = createEffect(() => {
    return this.actions$.pipe(
      ofType<AcquireUserAndBgDBLockAndThenReconcileForWashing>(
        BulkCountAppDBActionTypes.AcquireUserAndBgDBLockAndThenReconcileForWashing,
      ),
      switchMap((action) => {
        return this.bulkCountAppFacade.acquireUserAndBgDBLock('RECONCILE').pipe(
          take(1),
          switchMap(([bgLockResult, userLockResult]) => {
            if (bgLockResult.status === 'SUCCESS' && userLockResult.status === 'SUCCESS') {
              return of(new ReconcileUserDBAndBgDBAndThenReleaseLocksForWashing(action.chainAction, action.eventType));
            } else {
              if (action.showLockFailure) {
                if (userLockResult.status === 'FAILURE')
                  this.inputAppAPIHelperUtil.showPopup('Error', userLockResult.message);
                else if (bgLockResult.status === 'FAILURE')
                  this.inputAppAPIHelperUtil.showPopup('Error', bgLockResult.message);
              }
              if (bgLockResult.status === 'SUCCESS') return of(new ReleaseBgDBLock());
              else if (userLockResult.status === 'SUCCESS') return of(new ReleaseUserDBLock());
              return of(new BulkCountAppNoAction());
            }
          }),
        );
      }),
    );
  });

  ReconcileUserDBAndBgDBAndThenReleaseLocksForWashing$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ReconcileUserDBAndBgDBAndThenReleaseLocksForWashing>(
        BulkCountAppDBActionTypes.ReconcileUserDBAndBgDBAndThenReleaseLocksForWashing,
      ),
      switchMap((action) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          map((localStorageDb) => {
            return [localStorageDb, action] as const;
          }),
        ),
      ),

      switchMap(([userDB, action]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_BACKGROUND_DB]')).pipe(
          map((bgDB) => {
            return [userDB, bgDB, action] as const;
          }),
        ),
      ),
      switchMap(([userDB, bgDB, action]) => {
        // chainWithInitForLineChange and chainWithUndoWashingEvent carry the correct "SEND" or "RECEIVE" eventType
        const eventType =
          action.chainAction.chainWithInitForLineChange ??
          action.chainAction.chainWithUndoWashingEvent?.eventType ??
          'SEND';
        return this.bulkCountAppFacade
          .reconcileUserAndBgEventsDB(userDB, bgDB, userDB.dailyCache.nextCacheResetTimestamp, eventType)
          .pipe(
            take(1),
            map(([updatedUserDB, updatedBgDB]) => {
              return [updatedUserDB, updatedBgDB, action] as const;
            }),
          );
      }),
      switchMap(([updatedUserDB, updatedBgDB, action]) => {
        return from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_BACKGROUND_DB]', updatedBgDB)).pipe(
          take(1),
          switchMap(() => {
            return from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', updatedUserDB)).pipe(
              take(1),
              map(() => [updatedUserDB, updatedBgDB, action] as const),
            );
          }),
        );
      }),
      switchMap(([updatedUserDB, updatedBgDB, action]) => {
        return of(
          new SetUserDBAndBgDBAndReleaseLocksWithChainsForWashing(
            updatedUserDB,
            updatedBgDB,
            action.chainAction,
            action.eventType,
          ),
        );
      }),
    ),
  );

  SetUserDBAndBgDBAndReleaseLocksWithChains$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SetUserDBAndBgDBAndReleaseLocksWithChainsForWashing>(
        BulkCountAppDBActionTypes.SetUserDBAndBgDBAndReleaseLocksWithChainsForWashing,
      ),
      switchMap((action) => {
        if (action.chainAction.chainWithInitForLineChange) {
          this.bulkCountAppFacade.initLineChangeAfterSyncingPendingEvents(
            true,
            true,
            action.chainAction.chainWithInitForLineChange,
          );
        } else if (action.chainAction.chainWithAppUpdate) {
          this.bulkCountAppFacade.forceSyncEventsAndUpdateApp(
            action.eventType,
            action.chainAction.chainWithAppUpdate,
            true,
          );
        } else if (action.chainAction.reconcileAndShowAppUpdateError) {
          this.bulkCountAppFacade.emitAppUpdateSubscription(action.chainAction.reconcileAndShowAppUpdateError);
        } else if (action.chainAction.chainWithUndoWashingEvent) {
          this.bulkCountAppFacade.forceSyncPendingEventsAndThenUndoCurrentEvent(
            action.chainAction.chainWithUndoWashingEvent.eventType,
            true,
            true,
            action.chainAction.chainWithUndoWashingEvent,
          );
        }
        return of(new BulkCountAppNoAction());
      }),
    ),
  );

  AcquireBgDBLockAndThenSyncEvents$ = createEffect(() => {
    return this.actions$.pipe(
      ofType<AcquireBgDBLockAndThenSyncEvents>(BulkCountAppDBActionTypes.AcquireBgDBLockAndThenSyncEvents),
      switchMap((action) => {
        return this.bulkCountAppFacade.acquireBgDBLock('SYNC_EVENTS').pipe(
          take(1),
          switchMap((res) => {
            if (res.status === 'SUCCESS') {
              if (action.chainAction) {
                return this.bulkCountAppFacade.acquireUserDBLock('SYNCING_EVENTS').pipe(
                  take(1),
                  map((userDBLockRes) => {
                    if (userDBLockRes.status === 'SUCCESS') {
                      return new SyncEventsAndThenReleaseBgDBLock(
                        action.showLockFailure,
                        action.batchCount,
                        action.eventType,
                        action.chainAction,
                      );
                    } else {
                      this.inputAppAPIHelperUtil.showPopup('Error', userDBLockRes.message);
                      this.bulkCountAppFacade.releaseBgDBLock();
                      return new BulkCountAppNoAction();
                    }
                  }),
                );
              } else {
                return of(
                  new SyncEventsAndThenReleaseBgDBLock(
                    action.showLockFailure,
                    action.batchCount,
                    action.eventType,
                    action.chainAction,
                  ),
                );
              }
            } else {
              if (action.showLockFailure) {
                this.inputAppAPIHelperUtil.showPopup('Error', res.message);
              }
              return of(new BulkCountAppNoAction());
            }
          }),
        );
      }),
    );
  });

  SyncEventsAndThenReleaseBgDBLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncEventsAndThenReleaseBgDBLock>(BulkCountAppDBActionTypes.SyncEventsAndThenReleaseBgDBLock),
      switchMap((action) => {
        if (action.showLoader) {
          return from(this.inputAppAPIHelperUtil.presentLoading('Syncing pending events...')).pipe(
            take(1),
            map(() => [action] as const),
          );
        } else return of([action] as const);
      }),
      switchMap(([action]) => {
        return from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_BACKGROUND_DB]')).pipe(
          take(1),
          switchMap((bgDb) => {
            return from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
              take(1),
              switchMap((userDb) => {
                return this.bulkCountAppFacade.addMissingEventsStatusInBgDB(userDb.dailyCache.events.list, bgDb).pipe(
                  take(1),
                  map(([updatedBgDb, todaysEvents]) => {
                    return [updatedBgDb, todaysEvents, action] as const;
                  }),
                );
              }),
            );
          }),
        );
      }),
      switchMap(([bgDb, todaysEvents, action]) => {
        const pastDaysEventsInfo = bgDb.persistanceCache.pastDaysList;
        return this.bulkCountAppFacade
          .syncAtLeastOnePendingBulkEventWithBatchCountWrapper(
            pastDaysEventsInfo.length > 0 ? pastDaysEventsInfo : todaysEvents,
            action.batchCount,
            action.eventType,
          )
          .pipe(
            map((res) => {
              if (pastDaysEventsInfo.length > 0) {
                const lastSyncedIndex = BulkCountAppComputationHelper.getLastSyncedIndex(res.events);
                bgDb = produce(bgDb, (draft) => {
                  draft.persistanceCache.pastDaysList = res.events.slice(lastSyncedIndex + 1);
                });
                return [bgDb, res, action, true] as const;
              } else {
                bgDb = produce(bgDb, (draft) => {
                  draft.dailyCache.events.list = res.events.map((event) => event.backgroundMetadata);
                });
                bgDb = BulkCountAppComputationHelper.updateWipAndActualsForFailedEvents(
                  bgDb,
                  res.failedEventsIndices.map((index) => res.events[index]),
                  action.eventType,
                );
                return [bgDb, res, action, false] as const;
              }
            }),
            catchError((error) => {
              console.error('[SyncEventsAndThenReleaseBgDBLock] Error during sync:', error);
              this.bulkCountAppFacade.releaseBgDBLock();
              return of(new BulkCountAppNoAction());
            }),
          );
      }),
      switchMap((result) => {
        if (result instanceof BulkCountAppNoAction) return of(result);
        const [currentDB, syncEventsDTO, action, pastEventsSynced] = result;
        if (action.showLoader) {
          return from(this.inputAppAPIHelperUtil.dismissLoading()).pipe(
            take(1),
            map(() => [currentDB, syncEventsDTO, action, pastEventsSynced] as const),
          );
        } else return of([currentDB, syncEventsDTO, action, pastEventsSynced] as const);
      }),
      switchMap((result) => {
        if (result instanceof BulkCountAppNoAction) return of(result);
        const [currentDB, syncEventsDTO, action, pastEventsSynced] = result;
        return from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_BACKGROUND_DB]', currentDB)).pipe(
          map(() => {
            return new UpdateBgDBAndReleaseLockForSyncEvents(
              pastEventsSynced,
              currentDB,
              syncEventsDTO,
              action.eventType,
              action.chainAction,
            );
          }),
        );
      }),
    ),
  );

  UpdateBgDBAndReleaseLockForSyncEvents$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdateBgDBAndReleaseLockForSyncEvents>(BulkCountAppDBActionTypes.UpdateBgDBAndReleaseLockForSyncEvents),
      switchMap((action) => {
        if (!action.pastEventsSynced && action.syncEventsDTO.failedEventsIndices.length > 0) {
          const sizeAndCountList = action.syncEventsDTO.failedEventsIndices.map((failedIndex) => {
            return action.syncEventsDTO.events[failedIndex];
          });
          this.bulkCountAppFacade.showFailedEvents(sizeAndCountList);
        }
        if (action.chainAction) {
          if (action.syncEventsDTO.lastBatchSyncStatus === 'ALL_SYNCED') {
            this.bulkCountAppFacade.releaseUserDBLock();
            if (action.chainAction.chainWithInitForLineChange) {
              this.bulkCountAppFacade.initLineChangeAfterSyncingPendingEvents(
                true,
                false,
                action.chainAction.chainWithInitForLineChange,
              );
            } else if (action.chainAction.chainWithAppUpdate) {
              this.bulkCountAppFacade.reconcileAndShowErrorForAppUpdates(
                {
                  remoteDeploymentcheck: action.chainAction.chainWithAppUpdate,
                  syncResult: {
                    status:
                      action.syncEventsDTO.failedEventsIndices.length === 0
                        ? 'ALL_SYNCED'
                        : 'ALL_SYNCED_WITH_VALIDATION_ERRORS',
                  },
                },
                action.eventType,
              );
            } else if (action.chainAction.chainWithUndoWashingEvent) {
              this.bulkCountAppFacade.forceSyncPendingEventsAndThenUndoCurrentEvent(
                action.chainAction.chainWithUndoWashingEvent.eventType,
                true,
                false,
                action.chainAction.chainWithUndoWashingEvent,
              );
            }
            return of(new BulkCountAppNoAction());
          } else {
            return from(
              this.inputAppAPIHelperUtil.showPopup(
                'Error',
                `Cannot process the request as ${
                  action.pastEventsSynced ? 'Syncing past events' : 'Syncing pending events'
                } failed due to ${action.syncEventsDTO.lastBatchSyncStatus}`,
              ),
            ).pipe(
              take(1),
              map(() => {
                this.bulkCountAppFacade.releaseUserDBLock();
                return new BulkCountAppNoAction();
              }),
            );
          }
        } else return of(new BulkCountAppNoAction());
      }),
    ),
  );

  ChangeStation$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ChangeStation>(AppMasterDBActionTypes.ChangeStation),
      switchMap(() =>
        this.appMasterDBFacade.getAppIdentifier().pipe(
          take(1),
          map((appIdentifier) => {
            if (appIdentifier === 'bulk_washing_in_v2' || appIdentifier === 'bulk_washing_out_v2') {
              return new CheckStationOrShiftChange();
            } else return new BulkCountAppNoAction();
          }),
        ),
      ),
    ),
  );

  CheckStationOrShiftChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType<CheckStationOrShiftChange>(BulkCountAppDBActionTypes.CheckStationOrShiftChange),
      switchMap((action) =>
        this.bulkCountAppFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => [selectedStationAndShiftId, action] as const),
        ),
      ),
      switchMap(([selectedStationAndShiftId, action]) =>
        this.bulkCountAppFacade.getClientDB().pipe(
          take(1),
          map((userDB) => {
            return [selectedStationAndShiftId, userDB, action] as const;
          }),
        ),
      ),
      switchMap(([selectedStationAndShiftId, userDB, action]) =>
        this.appMasterDBFacade.getAppIdentifier().pipe(
          take(1),
          map((appIdentifier) => {
            return [selectedStationAndShiftId, userDB, action, appIdentifier] as const;
          }),
        ),
      ),
      switchMap(([selectedStationAndShiftId, userDB, action, appIdentifier]) => {
        const { stationId } = selectedStationAndShiftId;
        if (userDB.dailyCache.lineMap[stationId]) {
          return of(new BulkCountAppNoAction());
        } else {
          this.bulkCountAppFacade.initLineChangeAfterSyncingPendingEvents(
            false,
            false,
            appIdentifier === 'bulk_washing_in_v2' ? 'SEND' : 'RECEIVE',
          );
          return of(new BulkCountAppNoAction());
        }
      }),
    ),
  );

  AcquireUserDBLockAndRemoveTransaction$ = createEffect(() =>
    this.actions$.pipe(
      ofType<AcquireUserDBLockAndRemoveTransaction>(BulkCountAppDBActionTypes.AcquireUserDBLockAndRemoveTransaction),
      switchMap((action) => {
        return this.bulkCountAppFacade.acquireUserDBLock('PENDING_WORK_ADDITION').pipe(
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new RemoveTransactionAndThenReleaseLock(action.details);
            } else {
              this.inputAppAPIHelperUtil.showPopup('Error', res.message);
              return new BulkCountAppNoAction();
            }
          }),
        );
      }),
    ),
  );

  RemoveTransactionAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<RemoveTransactionAndThenReleaseLock>(BulkCountAppDBActionTypes.RemoveTransactionAndThenReleaseLock),
      switchMap((action) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            const { lineId, shiftId, bctxKey } = action.details.transaction;
            const pendingTransactions = currentDB.persistanceCache.pendingTransactions;
            const filteredPendingTransactions = pendingTransactions.filter(
              (item) => !(item.shiftId === shiftId && item.lineId === lineId && item.bctxKey === bctxKey),
            );
            currentDB = produce(currentDB, (draft) => {
              draft.persistanceCache.pendingTransactions = filteredPendingTransactions;
            });
            return [currentDB] as const;
          }),
        ),
      ),
      switchMap(([currentDB]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', currentDB)).pipe(
          take(1),
          map(() => new UpdateUserDBAndReleaseLock(currentDB)),
        ),
      ),
    ),
  );

  AcquireUserDBLockAndUpdatePendingWork$ = createEffect(() =>
    this.actions$.pipe(
      ofType<AcquireUserDBLockAndUpdatePendingWork>(BulkCountAppDBActionTypes.AcquireUserDBLockAndUpdatePendingWork),
      switchMap((action) => {
        return this.bulkCountAppFacade.acquireUserDBLock('PENDING_WORK_ADDITION').pipe(
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new UpdatePendingWorkAndThenReleaseLock(
                action.eventType,
                action.bctxList,
                action.vendorId,
                action.updatedSavedQty,
              );
            } else {
              this.inputAppAPIHelperUtil.showPopup('Error', res.message);
              return new BulkCountAppNoAction();
            }
          }),
        );
      }),
    ),
  );

  UpdatePendingWorkAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdatePendingWorkAndThenReleaseLock>(BulkCountAppDBActionTypes.UpdatePendingWorkAndThenReleaseLock),
      switchMap((action) =>
        this.bulkCountAppFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => [action, selectedStationAndShiftId] as const),
        ),
      ),
      switchMap(([action, selectedStationIdAndShiftId]) => {
        return this.bulkCountAppFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((bctxKeysOrder) => [action, selectedStationIdAndShiftId, bctxKeysOrder] as const),
        );
      }),
      switchMap(([action, selectedStationIdAndShiftId, bctxKeysOrder]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            const { stationId, shiftId } = selectedStationIdAndShiftId;
            const bctxKeyAndVendorId = BulkCountAppComputationHelper.getUniqueBctxKeyAndVendorIdWithOrder(
              bctxKeysOrder,
              action.bctxList,
              action.eventType === 'RECEIVE' ? action.vendorId : undefined,
            );
            const foundIndex = currentDB.persistanceCache.pendingTransactions.findIndex(
              (pendingTransaction) =>
                pendingTransaction.bctxKey === bctxKeyAndVendorId &&
                pendingTransaction.lineId === stationId &&
                pendingTransaction.shiftId === shiftId,
            );
            if (foundIndex > -1) {
              const updatedPendingTransactions = produce(currentDB.persistanceCache.pendingTransactions, (draft) => {
                draft[foundIndex].timeStamp = new Date().getTime();
                Object.entries(action.updatedSavedQty).forEach(([size, quantity]) => {
                  if (draft[foundIndex].sizeMap[size] && draft[foundIndex].sizeMap[size].savedCount > quantity) {
                    draft[foundIndex].sizeMap[size].savedCount = quantity;
                  }
                });
              });
              currentDB = produce(currentDB, (draft) => {
                draft.persistanceCache.pendingTransactions = updatedPendingTransactions;
              });
            }
            return [action, currentDB] as const;
          }),
        ),
      ),
      switchMap(([action, currentDB]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', currentDB)).pipe(
          take(1),
          map(() => new UpdateUserDBAndReleaseLock(currentDB)),
        ),
      ),
    ),
  );

  AcquireUserDBLockAndSavePendingWork$ = createEffect(() =>
    this.actions$.pipe(
      ofType<AcquireUserDBLockAndSavePendingWork>(BulkCountAppDBActionTypes.AcquireUserDBLockAndSavePendingWork),
      switchMap((action) => {
        return this.bulkCountAppFacade.acquireUserDBLock('PENDING_WORK_ADDITION').pipe(
          map((res) => {
            if (res.status === 'SUCCESS') {
              return new SavePendingWorkAndThenReleaseLock(
                action.eventType,
                action.bctxList,
                action.sizeList,
                action.vendorId,
              );
            } else {
              this.inputAppAPIHelperUtil.showPopup('Error', res.message);
              return new BulkCountAppNoAction();
            }
          }),
        );
      }),
    ),
  );

  SavePendingWorkAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SavePendingWorkAndThenReleaseLock>(BulkCountAppDBActionTypes.SavePendingWorkAndThenReleaseLock),
      switchMap((action) =>
        this.bulkCountAppFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => [action, selectedStationAndShiftId] as const),
        ),
      ),
      switchMap(([action, selectedStationIdAndShiftId]) => {
        return this.bulkCountAppFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((bctxKeysOrder) => [action, selectedStationIdAndShiftId, bctxKeysOrder] as const),
        );
      }),
      switchMap(([action, selectedStationIdAndShiftId, bctxKeysOrder]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            const { stationId, shiftId } = selectedStationIdAndShiftId;
            const bctxKeyAndVendorId = BulkCountAppComputationHelper.getUniqueBctxKeyAndVendorIdWithOrder(
              bctxKeysOrder,
              action.bctxList,
              action.eventType === 'RECEIVE' ? action.vendorId : undefined,
            );
            const foundIndex = currentDB.persistanceCache.pendingTransactions.findIndex(
              (pendingTransaction) =>
                pendingTransaction.bctxKey === bctxKeyAndVendorId &&
                pendingTransaction.lineId === stationId &&
                pendingTransaction.shiftId === shiftId,
            );
            const sizeMap = action.sizeList.reduce((acc, item) => {
              if (item.activeQty > 0) {
                acc[item.name] = {
                  name: item.name,
                  savedCount: item.activeQty,
                };
              }
              return acc;
            }, {} as Record<string, TSizeToSavedCountMap>);
            if (foundIndex > -1) {
              const updatedPendingTransactions = produce(currentDB.persistanceCache.pendingTransactions, (draft) => {
                draft[foundIndex].timeStamp = new Date().getTime();
                draft[foundIndex].sizeMap = sizeMap;
              });
              currentDB = produce(currentDB, (currentDBDraft) => {
                currentDBDraft.persistanceCache.pendingTransactions = updatedPendingTransactions;
              });
            } else {
              const updatedPendingTransactions = produce(currentDB.persistanceCache.pendingTransactions, (draft) => {
                draft.push({
                  lineId: stationId,
                  shiftId: shiftId,
                  bctxKey: bctxKeyAndVendorId,
                  timeStamp: new Date().getTime(),
                  vendorId: action.vendorId,
                  sizeMap: sizeMap,
                });
              });
              currentDB = produce(currentDB, (currentDBDraft) => {
                currentDBDraft.persistanceCache.pendingTransactions = updatedPendingTransactions;
              });
            }
            return [action, currentDB] as const;
          }),
        ),
      ),
      switchMap(([action, currentDB]) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', currentDB)).pipe(
          take(1),
          map(() => new UpdateUserDBAndReleaseLockAndThenRedirectToLandingPage(action.eventType, currentDB)),
        ),
      ),
    ),
  );

  UpdateUserDBAndReleaseLockAndThenRedirectToLandingPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdateUserDBAndReleaseLockAndThenRedirectToLandingPage>(
        BulkCountAppDBActionTypes.UpdateUserDBAndReleaseLockAndThenRedirectToLandingPage,
      ),
      switchMap((action) => {
        if (action.eventType === 'SEND') {
          this.router.navigate(['app-landing', 'bulk-washing-send', 'landing']);
        } else {
          this.router.navigate(['app-landing', 'bulk-washing-receive', 'landing']);
        }
        return of(new BulkCountAppNoAction());
      }),
    ),
  );

  AcquireUserDBLockAndSaveEvent$ = createEffect(() =>
    this.actions$.pipe(
      ofType<AcquireUserDBLockAndSaveEvent>(BulkCountAppDBActionTypes.AcquireUserDBLockAndSaveEvent),
      switchMap((action) => {
        return this.bulkCountAppFacade.acquireUserDBLock('EVENT_ADDITION').pipe(
          map((res) => {
            if (res.status === 'SUCCESS') {
              if (action.eventType === 'RECEIVE') {
                return new SaveReceiveEventkAndThenReleaseLock(action.bctxList, action.sizeList, action.vendorId);
              } else {
                return new SaveSendEventkAndThenReleaseLock(action.bctxList, action.sizeList, action.vendorId);
              }
            } else {
              this.inputAppAPIHelperUtil.showPopup('Error', res.message);
              return new BulkCountAppNoAction();
            }
          }),
        );
      }),
    ),
  );

  SaveSendEventkAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SaveSendEventkAndThenReleaseLock>(BulkCountAppDBActionTypes.SaveSendEventkAndThenReleaseLock),
      switchMap((action) =>
        this.bulkCountAppFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => [action, selectedStationAndShiftId] as const),
        ),
      ),
      switchMap(([action, selectedStationIdAndShiftId]) => {
        return this.bulkCountAppFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((bctxKeysOrder) => [action, selectedStationIdAndShiftId, bctxKeysOrder] as const),
        );
      }),
      switchMap(([action, selectedStationIdAndShiftId, bctxKeysOrder]) => {
        return this.bulkCountAppFacade.getSelectedStationAndShiftDTO().pipe(
          take(1),
          map((stationDetails) => [action, selectedStationIdAndShiftId, bctxKeysOrder, stationDetails] as const),
        );
      }),
      switchMap(([action, selectedStationIdAndShiftId, bctxKeysOrder, stationDetails]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            const event: TBulkWashingSendEvent = {
              type: 'SEND',
              metaData: {
                eventTime: new Date().getTime(),
                stationDetails,
                bctxWithoutSize: action.bctxList,
                bctxKey: BulkCountAppComputationHelper.getUniqueBctxKeyAndVendorIdWithOrder(
                  bctxKeysOrder,
                  action.bctxList,
                  undefined,
                ),
                vendorId: action.vendorId,
              },
              sizeQuantities: action.sizeList.map((item) => {
                return {
                  size: item.name,
                  quantity: item.activeQty,
                };
              }),
            };
            return produce(currentDB, (currentDBDraft) => {
              const { stationId, shiftId } = selectedStationIdAndShiftId;
              const bctxKeyAndVendorId = BulkCountAppComputationHelper.getUniqueBctxKeyAndVendorIdWithOrder(
                bctxKeysOrder,
                action.bctxList,
                undefined,
              );

              /** removing pending transaction if any */
              currentDBDraft.persistanceCache.pendingTransactions =
                currentDBDraft.persistanceCache.pendingTransactions.filter(
                  (item) =>
                    !(item.bctxKey === bctxKeyAndVendorId && item.lineId === stationId && item.shiftId === shiftId),
                );

              /** updating event list */
              currentDBDraft.dailyCache.events.list.push(event);

              /** updating wip and actuals */
              const totalQty = this.#applyQuantityDeltaToLineMap(
                currentDBDraft,
                'SEND',
                stationId,
                shiftId,
                bctxKeyAndVendorId,
                event.sizeQuantities,
                1,
              );

              /** update send total qty */
              currentDBDraft.dailyCache.totalCount += totalQty;
            });
          }),
          switchMap((currentDB) =>
            from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', currentDB)).pipe(
              take(1),
              map(() => new UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage('SEND', currentDB)),
            ),
          ),
          catchError((error) => {
            console.error('[SaveSendEvent] Error during produce or save, releasing lock:', error);
            return of(new ReleaseUserDBLock());
          }),
        ),
      ),
    ),
  );

  SaveReceiveEventkAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SaveReceiveEventkAndThenReleaseLock>(BulkCountAppDBActionTypes.SaveReceiveEventkAndThenReleaseLock),
      switchMap((action) =>
        this.bulkCountAppFacade.getSelectedStationIdAndShiftId().pipe(
          take(1),
          map((selectedStationAndShiftId) => [action, selectedStationAndShiftId] as const),
        ),
      ),
      switchMap(([action, selectedStationIdAndShiftId]) => {
        return this.bulkCountAppFacade.getBctxItemsOrderWithoutSize().pipe(
          take(1),
          map((bctxKeysOrder) => [action, selectedStationIdAndShiftId, bctxKeysOrder] as const),
        );
      }),
      switchMap(([action, selectedStationIdAndShiftId, bctxKeysOrder]) => {
        return this.bulkCountAppFacade.getSelectedStationAndShiftDTO().pipe(
          take(1),
          map((stationDetails) => [action, selectedStationIdAndShiftId, bctxKeysOrder, stationDetails] as const),
        );
      }),
      switchMap(([action, selectedStationIdAndShiftId, bctxKeysOrder, stationDetails]) =>
        from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')).pipe(
          take(1),
          map((currentDB) => {
            const event: TBulkWashingReceiveEvent = {
              type: 'RECEIVE',
              metaData: {
                eventTime: new Date().getTime(),
                stationDetails,
                bctxWithoutSize: action.bctxList,
                bctxKey: BulkCountAppComputationHelper.getUniqueBctxKeyAndVendorIdWithOrder(
                  bctxKeysOrder,
                  action.bctxList,
                  action.vendorId,
                ),
                vendorId: action.vendorId,
              },
              sizeQuantities: action.sizeList.map((item) => {
                return {
                  size: item.name,
                  quantity: item.activeQty,
                };
              }),
            };
            return produce(currentDB, (currentDBDraft) => {
              const { stationId, shiftId } = selectedStationIdAndShiftId;
              const bctxKeyAndVendorId = BulkCountAppComputationHelper.getUniqueBctxKeyAndVendorIdWithOrder(
                bctxKeysOrder,
                action.bctxList,
                action.vendorId,
              );

              /** removing pending transaction if any */
              currentDBDraft.persistanceCache.pendingTransactions =
                currentDBDraft.persistanceCache.pendingTransactions.filter(
                  (item) =>
                    !(item.bctxKey === bctxKeyAndVendorId && item.lineId === stationId && item.shiftId === shiftId),
                );

              /** updating event list */
              currentDBDraft.dailyCache.events.list.push(event);

              /** updating wip and actuals */
              const totalQty = this.#applyQuantityDeltaToLineMap(
                currentDBDraft,
                'RECEIVE',
                stationId,
                shiftId,
                bctxKeyAndVendorId,
                event.sizeQuantities,
                1,
              );

              /** updating total receive qty */
              currentDBDraft.dailyCache.totalCount += totalQty;
            });
          }),
        ),
      ),
      switchMap((currentDB) =>
        from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', currentDB)).pipe(
          take(1),
          map(() => new UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage('RECEIVE', currentDB)),
        ),
      ),
    ),
  );

  UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType<UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage>(
        BulkCountAppDBActionTypes.UpdateUserDBAndReleaseLockAndSynEventsAndRedirectToLandingPage,
      ),
      switchMap((action) => {
        if (this.bulkCountAppFacade.isWeb()) this.bulkCountAppFacade.backgroundSyncEvents(action.eventType);
        this.router.navigate([
          'app-landing',
          action.eventType === 'SEND' ? 'bulk-washing-send' : 'bulk-washing-receive',
          'landing',
        ]);
        return of(new BulkCountAppNoAction());
      }),
    ),
  );

  AcquireUserDBLockAndThenSyncTransactions$ = createEffect(() =>
    this.actions$.pipe(
      ofType<AcquireUserDBLockAndThenSyncTransactions>(
        BulkCountAppDBActionTypes.AcquireUserDBLockAndThenSyncTransactions,
      ),
      switchMap((action) => {
        return this.bulkCountAppFacade.acquireUserDBLock('BULK_COUNT_TRANSACTION_SYNC').pipe(
          map((res) => {
            if (res.status === 'SUCCESS') {
              if (action.eventType === 'RECEIVE') {
                return new SyncReceiveTransactionsAndThenReleaseLock(action.startTime, action.endTime);
              } else {
                return new SyncSendTransactionsAndThenReleaseLock(action.startTime, action.endTime);
              }
            } else {
              this.inputAppAPIHelperUtil.showPopup('Error', res.message);
              return new BulkCountAppNoAction();
            }
          }),
        );
      }),
    ),
  );

  SyncSendTransactionsAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncSendTransactionsAndThenReleaseLock>(BulkCountAppDBActionTypes.SyncSendTransactionsAndThenReleaseLock),
      switchMap((action) =>
        this.appMasterDBFacade.getWashingAppDetailsWithAdditionalInfo().pipe(
          take(1),
          map((appDetails) => [action, appDetails.factoryId] as const),
        ),
      ),
      switchMap(([action, factoryId]) => {
        return this.bulkCountAppFacade.getConfigurations().pipe(
          take(1),
          map(({ genericAppType, cacheResetTimestampInMilliSeconds }) => {
            return [action, factoryId, genericAppType, cacheResetTimestampInMilliSeconds] as const;
          }),
        );
      }),
      switchMap(([action, factoryId, genericAppType, cacheResetTimestampInMilliSeconds]) =>
        from(this.inputAppAPIHelperUtil.presentLoading('Loading transactions list...')).pipe(
          take(1),
          map(() => {
            const payload: TREQUEST_WashSendTransactionListingRequest = {
              factoryId,
              filters: [
                {
                  filterType: 'DATE',
                  values: [
                    new Date(action.startTime).setHours(0, 0, 0, 0) + cacheResetTimestampInMilliSeconds,
                    new Date(action.endTime).setHours(23, 59, 59, 999) + cacheResetTimestampInMilliSeconds,
                  ],
                },
              ],
              genericAppType,
            };
            return payload;
          }),
        ),
      ),
      switchMap((payload) =>
        this.bulkCountAppDataService.getSendTransactionListing(payload).pipe(
          map((res) => {
            this.inputAppAPIHelperUtil.dismissLoading();
            return new SyncTransactionsSuccessAndThenReleaseLock({
              type: 'SEND',
              res,
            });
          }),
          catchError((error) =>
            from(this.inputAppAPIHelperUtil.dismissLoading()).pipe(
              take(1),
              switchMap(() => from(this.inputAppAPIHelperUtil.showPopup('Error', 'Something went wrong'))),
              take(1),
              map(() => {
                console.log('[LOAD_SEND_TRANSAVTION_ERROR]', error);
                return new ReleaseUserDBLock();
              }),
            ),
          ),
        ),
      ),
    ),
  );

  SyncReceiveTransactionsAndThenReleaseLock$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SyncReceiveTransactionsAndThenReleaseLock>(
        BulkCountAppDBActionTypes.SyncReceiveTransactionsAndThenReleaseLock,
      ),
      switchMap((action) =>
        this.appMasterDBFacade.getWashingAppDetailsWithAdditionalInfo().pipe(
          take(1),
          map((appDetails) => [action, appDetails.factoryId] as const),
        ),
      ),
      switchMap(([action, factoryId]) => {
        return this.bulkCountAppFacade.getConfigurations().pipe(
          take(1),
          map(({ genericAppType, cacheResetTimestampInMilliSeconds }) => {
            return [action, factoryId, genericAppType, cacheResetTimestampInMilliSeconds] as const;
          }),
        );
      }),
      switchMap(([action, factoryId, genericAppType, cacheResetTimestampInMilliSeconds]) =>
        from(this.inputAppAPIHelperUtil.presentLoading('Loading transactions list...')).pipe(
          take(1),
          map(() => {
            const payload: TREQUEST_WashReceiveTransactionListingRequest = {
              factoryId,
              filters: [
                {
                  filterType: 'DATE',
                  values: [
                    new Date(action.startTime).setHours(0, 0, 0, 0) + cacheResetTimestampInMilliSeconds,
                    new Date(action.endTime).setHours(23, 59, 59, 999) + cacheResetTimestampInMilliSeconds,
                  ],
                },
              ],
              genericAppType,
            };
            return payload;
          }),
        ),
      ),
      switchMap((payload) =>
        this.bulkCountAppDataService.getReceivesTransactionListing(payload).pipe(
          map((res) => {
            this.inputAppAPIHelperUtil.dismissLoading();
            return new SyncTransactionsSuccessAndThenReleaseLock({
              type: 'RECEIVE',
              res,
            });
          }),
          catchError((error) =>
            from(this.inputAppAPIHelperUtil.dismissLoading()).pipe(
              take(1),
              switchMap(() => from(this.inputAppAPIHelperUtil.showPopup('Error', 'Something went wrong'))),
              take(1),
              map(() => {
                console.log('[LOAD_RECEIVE_TRANSAVTION_ERROR]', error);
                return new ReleaseUserDBLock();
              }),
            ),
          ),
        ),
      ),
    ),
  );

  #acquireUndoLock<TAction>(action: TAction) {
    return this.appMasterDBFacade.getWashingAppDetailsWithAdditionalInfo().pipe(
      take(1),
      switchMap((washingAppDetails) =>
        this.bulkCountAppFacade.acquireUserDBLock('VALIDATING_UNDO').pipe(
          take(1),
          map((lockRes) => [action, washingAppDetails, lockRes] as const),
        ),
      ),
    );
  }

  #getUndoContext() {
    return forkJoin({
      stationAndShift: this.bulkCountAppFacade.getSelectedStationIdAndShiftId().pipe(take(1)),
      orderKeys: this.bulkCountAppFacade.getBctxItemsOrderWithoutSize().pipe(take(1)),
      userDB: from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_DB]')),
      bgDB: from(this.persistentStorageService.get('[APP][INPUT_APP_BULK_COUNT_BACKGROUND_DB]')),
    });
  }

  #applyQuantityDeltaToLineMap(
    draft: TBulkCountAppUserActualsDB,
    eventType: TBulkWashingEventType,
    stationId: string,
    shiftId: string,
    bctxKey: string,
    sizeQuantities: TSizeQuantity[],
    direction: 1 | -1,
  ): number {
    const stationLineMap = draft.dailyCache.lineMap[stationId];
    const wipMapItem = eventType === 'SEND' ? stationLineMap.bctxAndVendorWipMap[bctxKey] : undefined;
    const actualMapItem = stationLineMap.shiftMap[shiftId]?.[bctxKey];
    if ((eventType === 'SEND' && !wipMapItem) || !actualMapItem) {
      this.customLoggerService.error(
        `[applyQuantityDeltaToLineMap][${eventType}] lineMap entry not found for key:`,
        bctxKey,
      );
      return 0;
    }
    let totalQty = 0;
    sizeQuantities.forEach((sizeQty) => {
      if (wipMapItem) {
        (wipMapItem.sizeMap[sizeQty.size] as TSizeToUserDBWipMapItem).wipQty -= direction * sizeQty.quantity;
      }
      (actualMapItem.sizeMap[sizeQty.size] as TSizeToUserDBActualMapItem).totalCompletedCount +=
        direction * sizeQty.quantity;
      totalQty += sizeQty.quantity;
    });
    return totalQty;
  }

  #buildUpdatedUserDBForUndo(
    userDB: TBulkCountAppUserActualsDB,
    eventType: TBulkWashingEventType,
    stationId: string | undefined,
    shiftId: string | undefined,
    bctxKey: string,
    sizeQuantities: TSizeQuantity[],
    qtyToDecrement: number,
  ): TBulkCountAppUserActualsDB {
    return produce(userDB, (draft) => {
      draft.dailyCache.totalCount = Math.max(0, draft.dailyCache.totalCount - qtyToDecrement);
      if (bctxKey && stationId && shiftId) {
        this.#applyQuantityDeltaToLineMap(draft, eventType, stationId, shiftId, bctxKey, sizeQuantities, -1);
      }
    });
  }

  AcquireUserDBLockAndUndoWashingSendEvent$ = createEffect(() =>
    this.actions$.pipe(
      ofType<AcquireUserDBLockAndUndoWashingSendEvent>(
        BulkCountAppDBActionTypes.AcquireUserDBLockAndUndoWashingSendEvent,
      ),
      concatMap((action) => this.#acquireUndoLock(action)),
      concatMap(([action, washingAppDetails, lockRes]) => {
        if (lockRes.status !== 'SUCCESS') {
          this.inputAppAPIHelperUtil.showPopup('Error', lockRes.message);
          return of(new BulkCountAppNoAction());
        }
        const payload: TREQUEST_WashSendTransactionUndo = {
          factoryId: washingAppDetails.factoryId,
          transactionId: action.payload.transactionId,
          appDetails: washingAppDetails,
        };
        const sizeQuantities = action.payload.sizeQuantities;
        const bctxWithoutSize = action.payload.bctxWithoutSize.filter((x) => x.v !== null);
        const qtyToDecrement = sizeQuantities.reduce((sum, sq) => sum + sq.quantity, 0);
        return from(this.inputAppAPIHelperUtil.presentLoading(this.translate.instant('bulk_washing_undo.loading'))).pipe(
          switchMap(() => this.bulkCountAppDataService.undoSendTransaction(payload)),
          switchMap(() => {
            this.inputAppAPIHelperUtil.dismissLoading();
            return from(this.inputAppAPIHelperUtil.showToast(this.translate.instant('bulk_washing_undo.success'))).pipe(
              take(1),
              switchMap(() =>
                this.#getUndoContext().pipe(
                  switchMap(({ stationAndShift, orderKeys, userDB, bgDB }) => {
                    const { stationId, shiftId } = stationAndShift;
                    const bctxKey =
                      bctxWithoutSize.length > 0
                        ? BulkCountAppComputationHelper.getUniqueBctxKeyAndVendorIdWithOrder(
                            orderKeys,
                            bctxWithoutSize,
                            undefined,
                          )
                        : '';
                    const updatedUserDB = this.#buildUpdatedUserDBForUndo(
                      userDB,
                      'SEND',
                      stationId,
                      shiftId,
                      bctxKey,
                      sizeQuantities,
                      qtyToDecrement,
                    );
                    return from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', updatedUserDB)).pipe(
                      take(1),
                      concatMap(() => {
                        const actions: Action[] = [new SetUserDBAndBackgoundDBAndReleaseLock(updatedUserDB, bgDB)];
                        if (action.startTime > 0) {
                          actions.push(
                            new AcquireUserDBLockAndThenSyncTransactions('SEND', action.startTime, action.endTime),
                          );
                        }
                        return actions;
                      }),
                    );
                  }),
                ),
              ),
            );
          }),
          catchError((error) => {
            this.inputAppAPIHelperUtil.dismissLoading();
            return from(
              this.inputAppAPIHelperUtil.showPopup('Error', this.translate.instant('common.somethingWentWrong')),
            ).pipe(
              take(1),
              map(() => {
                console.log('[UNDO_WASHING_EVENT_ERROR]', error);
                return new ReleaseUserDBLock();
              }),
            );
          }),
        );
      }),
    ),
  );

  AcquireUserDBLockAndUndoWashingReceiveEvent$ = createEffect(() =>
    this.actions$.pipe(
      ofType<AcquireUserDBLockAndUndoWashingReceiveEvent>(
        BulkCountAppDBActionTypes.AcquireUserDBLockAndUndoWashingReceiveEvent,
      ),
      concatMap((action) => this.#acquireUndoLock(action)),
      concatMap(([action, washingAppDetails, lockRes]) => {
        if (lockRes.status !== 'SUCCESS') {
          this.inputAppAPIHelperUtil.showPopup('Error', lockRes.message);
          return of(new BulkCountAppNoAction());
        }
        const payload: TREQUEST_WashReceiveTransactionUndo = {
          factoryId: washingAppDetails.factoryId,
          transactionId: action.payload.transactionId,
          appDetails: washingAppDetails,
        };
        const sizeQuantities = action.payload.sizeQuantities;
        const bctxWithoutSize = action.payload.bctxWithoutSize.filter((x) => x.v !== null);
        const qtyToDecrement = sizeQuantities.reduce((sum, sq) => sum + sq.quantity, 0);
        const vendorId = action.payload.vendorId;
        return from(this.inputAppAPIHelperUtil.presentLoading(this.translate.instant('bulk_washing_undo.loading'))).pipe(
          switchMap(() => this.bulkCountAppDataService.undoReceiveTransaction(payload)),
          switchMap(() => {
            this.inputAppAPIHelperUtil.dismissLoading();
            return from(this.inputAppAPIHelperUtil.showToast(this.translate.instant('bulk_washing_undo.success'))).pipe(
              take(1),
              switchMap(() =>
                this.#getUndoContext().pipe(
                  switchMap(({ stationAndShift, orderKeys, userDB, bgDB }) => {
                    const { stationId, shiftId } = stationAndShift;
                    // RECEIVE keys include vendorId
                    const bctxKey =
                      bctxWithoutSize.length > 0
                        ? BulkCountAppComputationHelper.getUniqueBctxKeyAndVendorIdWithOrder(
                            orderKeys,
                            bctxWithoutSize,
                            vendorId,
                          )
                        : '';
                    const updatedUserDB = this.#buildUpdatedUserDBForUndo(
                      userDB,
                      'RECEIVE',
                      stationId,
                      shiftId,
                      bctxKey,
                      sizeQuantities,
                      qtyToDecrement,
                    );
                    return from(this.persistentStorageService.set('[APP][INPUT_APP_BULK_COUNT_DB]', updatedUserDB)).pipe(
                      take(1),
                      concatMap(() => {
                        const actions: Action[] = [new SetUserDBAndBackgoundDBAndReleaseLock(updatedUserDB, bgDB)];
                        if (action.startTime > 0) {
                          actions.push(
                            new AcquireUserDBLockAndThenSyncTransactions('RECEIVE', action.startTime, action.endTime),
                          );
                        }
                        return actions;
                      }),
                    );
                  }),
                ),
              ),
            );
          }),
          catchError((error) => {
            this.inputAppAPIHelperUtil.dismissLoading();
            return from(
              this.inputAppAPIHelperUtil.showPopup('Error', this.translate.instant('common.somethingWentWrong')),
            ).pipe(
              take(1),
              map(() => {
                console.log('[UNDO_RECEIVE_WASHING_EVENT_ERROR]', error);
                return new ReleaseUserDBLock();
              }),
            );
          }),
        );
      }),
    ),
  );

}
